export function getServiceWorkerNavigationPath(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;

  const message = data as { type?: unknown; url?: unknown };
  if (message.type !== 'NAV' || typeof message.url !== 'string') return null;

  // Push payloads are external input. Only accept same-origin absolute paths.
  if (!message.url.startsWith('/') || message.url.startsWith('//') || message.url.includes('\\')) {
    return null;
  }

  return message.url;
}
